<template>
	<div class="small-class">
		<div class="small-class-header">
			<span style="margin-left:15px">{{smallClassTitle}}店铺级小类</span>
		</div>
		<div class="small-class-btn-box">
			<el-button v-if="AuthorityList['01_0005_0005_00']" size="mini" class="btn-style" @click="addCategory" type="primary" plain>新增</el-button>
			<el-button v-if="AuthorityList['01_0005_0007_00']" size="mini" class="btn-style" @click="deleteCategoryMuliti" type="primary" plain>删除</el-button>
			<el-button v-if="AuthorityList['01_0005_0015_00']" size="mini" class="btn-style" @click="openCategory(true)" type="primary" plain>启用</el-button>
			<el-button v-if="AuthorityList['01_0005_0016_00']" size="mini" class="btn-style" @click="openCategory(false)" type="primary" plain>停用</el-button>
			<el-button v-if="AuthorityList['01_0005_0008_00']" size="mini" class="btn-style" @click="sortCategory" type="primary" plain>排序</el-button>
			<div class="small-class-search-box">
				<el-input
					placeholder="请输入内容"
					v-model="searchKey"
					clearable
					class="search-input"
					size="mini"
					@keyup.enter.native="onSearch"></el-input>
				<el-button
					type="primary"
					icon="el-icon-search"
					class="search-btn"
					size="mini"
					@click="onSearch"></el-button>
			</div>
		</div>
		<el-table class="small-class-table" size='mini' :data="smallTableData" border height="100%" @selection-change="tableSelect">
			<el-table-column type="selection"  align="center" width="55"></el-table-column>
			<el-table-column align="center"
				prop="name"
				label="店铺级小类"
				min-width="150">
			</el-table-column>
			<el-table-column align="center"
				prop="bcName"
				label="店铺级大类"
				min-width="150">
			</el-table-column>
			<el-table-column align="center"
				prop="disableflag"
				label="店铺级小类停用标记"
				min-width="160">
				<template slot-scope="scope">
					<div v-if="!scope.row.disabledflag">启用</div>
					<div v-else>停用</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" min-width="180" class-name="last-colum">
				<template slot-scope="scope">
					<el-button
						v-if="AuthorityList['01_0005_0006_00']"
						icon="el-icon-edit"
						size="mini"
						type='text'
						@click="editCategory(scope.$index, scope.row)">编辑</el-button>
					<el-button
						v-if="AuthorityList['01_0005_0007_00']"
						icon="el-icon-delete"
						size="mini"
						type='text'
						@click="deleteCategory(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="editSmallClassTitle" :visible.sync="addCategoryVisible" width="600px" :close-on-click-modal="false">
			<AddSmallClass
				v-if='addCategoryVisible'
				:visibleFlag.sync="addCategoryVisible"
				:data="editSmallClass"
				:templateId="templateId"
				:thirdCategoryEnabled="thirdCategoryEnabled"
				@refreshData="refreshData">
			</AddSmallClass>
		</el-dialog>
		<el-dialog :title="sortSmallClassTitle" :visible.sync="sortCategoryVisible" width="800px" custom-class="sort-class-dialog" :close-on-click-modal="false">
			<SortSmallClass
				:visibleFlag.sync="sortCategoryVisible"
				:data="sortClassData"
				@refreshData="refreshData">
			</SortSmallClass>
		</el-dialog>
		<el-dialog title="查看图片" :visible.sync="smallIconVisible" width="300px" :close-on-click-modal="false">
			<div style="display: flex;justify-content: center;">
				<img src="~images/img/login.jpg" alt="" class="look-small-icon" @click="loogIcon">
			</div>
		</el-dialog>

	</div>
</template>

<script>
import AddSmallClass from '@/components/categoryManagement/AddSmallClass.vue'
import SortSmallClass from '@/components/categoryManagement/SortSmallClass.vue'

export default {
	name: 'HelloWorld',
	components: {
		AddSmallClass,
		SortSmallClass
	},
	props: {
		AuthorityList: Object,
		smallClassData: {
			type: Object,
			default: () => {}
		},
		smallTableData: {
			type: Array,
			default: () => []
		},
		templateId: {
			type: String,
			default: ''
		},
		thirdCategoryEnabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			categoryDefaultIcon: '',
			addCategoryVisible: false,
			editSmallClass: {},
			sortCategoryVisible: false,
			sortClassData: [],
			multipleSelection: [],
			searchKey: '',
			smallIconVisible: false
		}
	},
	watch: {
		smallClassData: {
			handler (val) {
				console.log(val)
			},
			immediate: true
		}
	},
	computed: {
		smallClassTitle () {
			let bcName = this.smallClassData.bc_name
			if (bcName && bcName !== '全部') {
				return `【${bcName}】`
			} else {
				return ''
			}
		},
		editSmallClassTitle () {
			let bigClass = this.smallClassData.bc_name
			if (this.editSmallClass.name === undefined) {
				return `新增【${bigClass}】店铺级小类`
			} else {
				return `修改【${bigClass}】店铺级小类【${this.editSmallClass.name}】`
			}
		},
		sortSmallClassTitle () {
			let bigClass = this.smallClassData.bc_name
			return `【${bigClass}】店铺级小类排序`
		}
	},
	methods: {
		loogIcon () {
			this.smallIconVisible = true
		},
		refreshData () {
			this.$emit('refreshData')
		},
		onSearch () {
			this.$emit('onSearch', this.searchKey)
		},
		tableSelect (val) {
			this.multipleSelection = val
		},
		addCategory () {
			if (this.$fxUtils.isEmptyObjSHW(this.smallClassData) || this.smallClassData.bc_name === '全部') {
				this.$confirm(`请选择一个店铺级大类!`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
				return false
			}
			this.editSmallClass = {}
			this.addCategoryVisible = true
		},
		editCategory (index, row) {
			this.editSmallClass = row
			this.addCategoryVisible = true
		},
		sortCategory () {
			if (this.smallTableData === undefined) {
				return false
			}
			this.sortClassData = JSON.parse(JSON.stringify(this.smallTableData))
			this.sortCategoryVisible = true
		},
		deleteCategory (index, row) {
			this.$confirm(`是否删除店铺级小类【${row.name}】?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.deleteSmall(row)
				// let param = {
				// 	id: row.id,
				// 	type: 1,
				// 	imgUrl: '',
				// 	syscodeid: row.syscodeid
				// }
				// this.$store.dispatch('requestPost', {
				// 	url: `${this.$fxBaseApi.urlQIV}/shop/deleteShopCategory/checkCanRemove`,
				// 	data: [param]
				// }).then(res => {
				// 	if (res.result) {
				// 		if (res.data.resultFlag) {
				// 			this.deleteSmall(row)
				// 		} else {
				// 			let a = res.data.message
				// 			let b = a.join(',')
				// 			this.$confirm(`店铺级小类${b}下已关联商品，删除后商品将进入全部商品列表，是否继续？`, '提示', {
				// 				confirmButtonText: '确定',
				// 				cancelButtonText: '取消',
				// 				type: 'warning',
				// 				closeOnClickModal: false
				// 			}).then(() => {
				// 				this.deleteSmall(row)
				// 			}).catch(() => {

				// 			})
				// 		}
				// 	} else {
				// 		this.$message.error(res.msg)
				// 	}
				// })
			}).catch(() => {

			})
		},
		deleteSmall (row) {
			let param = {
				ids: row.id,
				type: 1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/deleteShopCategory`,
				data: param
			}).then(res => {
				if (res.result) {
					this.$message({
						message: `删除店铺级小类【${row.name}】成功!`,
						type: 'success'
					})
					this.refreshData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteCategoryMuliti () {
			this.checkSelectClass().then(() => {
				this.$confirm(`是否删除选中的店铺级小类?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.deleteList()
				})
			})
		},
		deleteList () {
			// let idsArr = this.multipleSelection
			// let arr = []
			// for (let i = 0; i < idsArr.length; i++) {
			// 	let a = {
			// 		id: idsArr[i].id,
			// 		type: 1,
			// 		imgUrl: '',
			// 		syscodeid: idsArr[i].syscodeid
			// 	}
			// 	arr.push(a)
			// }
			let ids = this.multipleSelection.map(e => {
				return e.id
			})
			let param = {
				ids: ids.join(','),
				type: 1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/deleteShopCategory`,
				data: param
			}).then(res => {
				if (res.result) {
					this.$message({
						message: `删除店铺级小类成功!`,
						type: 'success'
					})
					this.refreshData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 停用启用
		openCategory (openFlage) {
			let openText = openFlage ? '启用' : '停用'
			let disableFlag = openFlage ? 0 : 1
			let ids = this.multipleSelection.map(e => {
				return e.id
			})
			this.checkSelectClass().then((data) => {
				this.$confirm(`是否${openText}选中的店铺级小类?`, '提示', {
					confirmButtonText: '是',
					cancelButtonText: '否',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let param = {
						ids: ids.join(','),
						disabledFlag: disableFlag
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIV}/shop/stopShopCategory`,
						data: param
					}).then(res => {
						if (res.result) {
							this.$message({
								message: `${openText}店铺级小类成功!`,
								type: 'success'
							})
							this.refreshData()
						} else {
							this.$message.error(res.msg)
						}
					})
				})
			})
		},
		checkSelectClass () {
			return new Promise(resolve => {
				let length = this.multipleSelection.length
				if (length === 0) {
					this.$alert('请选择一个店铺级小类!', '提示', {
						confirmButtonText: '确定'
					})
				} else {
					resolve()
				}
			})
		}
	}
}
</script>
<style scoped lang="stylus">
@import '~$assets/stylus/varsty.styl'
.small-class {
	height:100%
	display:flex;
	flex-direction: column;
	.btn-style {
		width:80px
	}
	.small-icon {
		width: 50px
		height: 50px
		cursor: pointer
	}
	.look-small-icon {
		width: 150px
		height: 150px
	}
	.small-class-header {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #eee;
		text-align:left
		padding-left: 5px;
		position:relative
		&::before {
					content: ''
					position:absolute
					height:20px
					width:3px
					background:$fxDefaultColor
					top: 9px;
					left: 10px;
				}
	}
	.small-class-btn-box {
		text-align:left
		margin:10px
		.small-class-search-box {
			float:right
			width:200px
			display:flex
			flex-direction:row
			.search-btn {
				height:28px
				border-top-left-radius:0px !important
				border-bottom-left-radius:0px !important
			}
		}
	}
	.small-class-table {
		flex:1
		width:100%
		border-right: none
		border-left: none
		.last-colum {
			border-right: none !important
		}
		.small-class-icon {
			display: inline-block;
			height: 24px;
			width: 24px;
			vertical-align: middle;
		}
		.class-disabled-icon {
			border:1px solid $fxRed
			color:$fxRed
			margin-left: 5px;
			padding:2px
		}
	}
}
</style>
<style lang="stylus">
.small-class {
	.small-class-search-box {
		.search-input {
			.el-input__inner {
				border-top-right-radius:0px !important
				border-bottom-right-radius:0px !important
			}
		}
	}
	.small-class-table {
		.last-colum {
			border-right: none !important
		}
		.el-table__body-wrapper::-webkit-scrollbar {
			width: 10px;
			background-color: #F5F5F5;
		}
		.el-table__body-wrapper::-webkit-scrollbar-thumb {
			border-radius: 10px;
			-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
			background-color: #ccc;
		}
		.el-table__body-wrapper::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
			background-color: #F5F5F5;
			border-radius: 10px;
		}
	}
}
</style>
